import type { Runtime } from '@/core/enums/runtime.enum'
import type { ClassData, FieldData } from '@/core/types/library.type'

import type { UseMemberExecutionResult } from './types'
import { useMemberExecution } from './useMemberExecution'

export interface UseFieldExecutionParams {
  field: FieldData
  classData: ClassData
  runtimeName: Runtime
}

export function useFieldExecution({
  field,
  classData,
  runtimeName,
}: UseFieldExecutionParams): UseMemberExecutionResult {
  return useMemberExecution({ member: { kind: 'field', field }, classData, runtimeName })
}
